import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectFetchReportStatus = createSelector(
  [(store: RootState) => store.documentsList.fetchReportStatus],
  (data) => data
);
